/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var TimeWindow;
(function (TimeWindow) {
    TimeWindow["HOURLY"] = "hourly";
    TimeWindow["DAILY"] = "daily";
    TimeWindow["WEEKLY"] = "weekly";
    TimeWindow["AUTO"] = "auto";
})(TimeWindow || (TimeWindow = {}));
